import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class TargetCalculationFilterData {
    targetObjects: Array<DropdownOptionIntegerId>;
    targetObjectAttributes: Array<DropdownOptionIntegerId>;
    calculationTypes: Array<DropdownOptionIntegerId>;
}
